import React, { useEffect, useRef, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import { Box, Container, Grid } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import EzControlledCalendarWithFloatingLabel from "../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../utils/form/form-utils";
import EzControlledInputWithFloatingLabel from "../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import EzControlledDropDowntWithFloatingLabel from "../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import EzControlledMultiSelecttWithFloatingLabel from "../../../common/EzForm/EzControlledMultiSelect/WithFloatingLabel";

import {
  bookingTypeDD,
  listStatusDD,
  ReservationsReservationsBreadcrumb,
} from "../ReservationsReservations/CreateReservationsReservations/constant";
import { printTableData } from "../../../utils/printUtils";
const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;

const ReservationsReservations = (props) => {
  const classes = useStyles();
  const {
    fetchReservationsReservations,
    tableData,
    setDeleteConfirmationPopupVisibility,
    exportReservationsReservations,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateReservationsReservations,
    editReservationsReservationsRoute,
    RateNetworkDD,
    locationDD,
    reservationFilters,
    setReservationFilters,
    clearReservationFilters,
    handleNoShowClick,
    reservationSummary,
    tableColumnFilters,
    setTableColumnFilters,
    clearTableColumnFilters,
    onTableStateChange,
    savedTableState,
  } = props;

  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: reservationFilters,
  });

  useEffect(() => {
    reset(reservationFilters);
  }, [reservationFilters, reset]);

  const [isCopy, setIsCopy] = useState(false);
  const [isPrintError, setIsPrintError] = useState(false);
  const [areFiltersVisible, toggleFilterState] = useState(true);
  const [isSearch, setIsSearch] = useState(false);

  const convertToTSV = (data) => {
    const headers = data.columns.map((item) => item.colLabel).join("\t");
    //const headers = Object.keys(data.rows[0]).join('\t');
    const rows = data.rows
      .map((row) => Object.values(row).join("\t"))
      .join("\n");
    return `${headers}\n${rows}`;
  };
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };
  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => setIsCopy(true));
  };
  useEffect(() => {
    setTimeout(
      () => setIsCopy(false),

      1000,
    );
  }, [isCopy]);

  useEffect(() => {
    if (isPrintError) {
      setTimeout(() => setIsPrintError(false), 3000);
    }
  }, [isPrintError]);

  const handlePrint = () => {
    const success = printTableData({
      title: "Reservations Report",
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
      excludeColumns: ["id"],
      orientation: "landscape",
    });

    if (!success) {
      setIsPrintError(true);
    }
  };

  const handleExport = () => {
    const exportPayload = {
      additinalFilter: reservationFilters,
    };
    exportReservationsReservations(exportPayload);
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Reservations</h4>
            <Button
              label={areFiltersVisible ? "Hide Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary shadow-btn`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              {screenPermissions?.create && (
                <Button
                  label={"Create Reservations"}
                  className={` p-button-raised`}
                  style={{ borderRadius: "0px" }}
                  onClick={handleCreateReservationsReservations}
                />
              )}
            </div>
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handleExport}
              />
              <Button
                label={"Print"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();
  
  // Memoize filters to prevent unnecessary re-renders and ensure stable reference
  const filters = useMemo(() => {
    const getFilterValue = (key) => tableColumnFilters?.[key] ?? null;
    return {
      global: { value: null },
      ref: { value: getFilterValue("ref"), filterKey: "ref" },
      networkTitle: { value: getFilterValue("networkTitle"), filterKey: "networkTitle" },
      locationTitle: { value: getFilterValue("locationTitle"), filterKey: "locationTitle" },
      vehicle: { value: getFilterValue("vehicle"), filterKey: "vehicle" },
      bookingDate: { value: getFilterValue("bookingDate"), filterKey: "bookingDate" },
      pickup: { value: getFilterValue("pickup"), filterKey: "pickup" },
      dropoff: { value: getFilterValue("dropoff"), filterKey: "dropoff" },
      currencyCode: { value: getFilterValue("currencyCode"), filterKey: "currencyCode" },
      totalAmount: { value: getFilterValue("totalAmount"), filterKey: "totalAmount" },
      days: { value: getFilterValue("days"), filterKey: "days" },
      name: { value: getFilterValue("name"), filterKey: "name" },
      paymentStatus: { value: getFilterValue("paymentStatus"), filterKey: "paymentStatus" },
      rateType: { value: getFilterValue("rateType"), filterKey: "rateType" },
      status: { value: getFilterValue("status"), filterKey: "status" },
    };
  }, [tableColumnFilters]);

  const getToastProps = () => {
    if (isCopy) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Data copied to clipboard!",
        shouldShowToast: true,
      };
    }

    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Please allow popups to use the print feature.",
        shouldShowToast: true,
      };
    }

    return {};
  };
  const onSubmit = (data) => {
    setIsSearch(true);
    const newFilters = { ...data };
    setReservationFilters(newFilters);
    // Always call API on explicit search button click
    fetchReservationsReservations({
      pageNumber: 0,
      pageSize: paginationInfo?.pageSize || 10,
      sortField: "id",
      additinalFilter: newFilters,
    });
  };
  const handleResetFilters = () => {
    clearReservationFilters();
    clearTableColumnFilters();
    setIsSearch(false);
    reset({
      startDate: "",
      endDate: "",
      type: "pickupDate",
      location: "",
      network: "",
      status: 0,
    });
  };
  
  // Callback to save table column filters when they change
  const handleTableFilterChange = (newFilters) => {
    // Extract just the filter values from the filters object
    const filterValues = {};
    Object.keys(newFilters).forEach(key => {
      if (key !== 'global' && newFilters[key]?.value !== null && newFilters[key]?.value !== undefined) {
        filterValues[key] = newFilters[key].value;
      }
    });
    setTableColumnFilters(filterValues);
  };
  
  const tableProps = {
    columns: tableData?.columns,
    paginationInfo,
    areFiltersVisible,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Reservations found.",
    filters,
    loadLazyData: fetchReservationsReservations,
    loading: isLoading,
    showMoreActions: false,
    sortField: savedTableState?.sortField || "id",
    initialSortOrder: savedTableState?.sortOrder,
    initialFirst: savedTableState?.first || 0,
    initialRows: savedTableState?.rows || 10,
    setDeleteConfirmationPopupVisibility,
    onViewRecord: editReservationsReservationsRoute,
    additinalFilter: reservationFilters,
    isSearch,
    showViewButton: true,
    showCopyButton: false,
    showDeleteButton: false,
    showEditButton: false,
    onNoShowClick: handleNoShowClick,
    onTableFilterChange: handleTableFilterChange,
    onTableStateChange,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={ReservationsReservationsBreadcrumb} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}

          <div className="form-demo mt20">
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid mt-2">
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledCalendarWithFloatingLabel
                    id="startDate"
                    name="startDate"
                    {...register("startDate")}
                    showTime={false}
                    maxDate={new Date(2090, 0, 1)}
                    dateFormat="yy/mm/dd"
                    control={control}
                    isError={errors["startDate"]}
                    errorMsg={getFormErrorMessage("startDate")}
                    label="Start Date"
                    rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledCalendarWithFloatingLabel
                    id="endDate"
                    name="endDate"
                    {...register("endDate")}
                    showTime={false}
                    maxDate={new Date(2090, 0, 1)}
                    dateFormat="yy/mm/dd"
                    control={control}
                    isError={errors["endDate"]}
                    errorMsg={getFormErrorMessage("endDate")}
                    label="End Date"
                    rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledDropDowntWithFloatingLabel
                    name="type"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={bookingTypeDD}
                    isError={errors["type"]}
                    errorMsg={getFormErrorMessage("type")}
                    label="Type"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledMultiSelecttWithFloatingLabel
                    name="location"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={locationDD}
                    isError={errors["location"]}
                    errorMsg={getFormErrorMessage("location")}
                    label="Location"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledMultiSelecttWithFloatingLabel
                    name="network"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={RateNetworkDD}
                    isError={errors["network"]}
                    errorMsg={getFormErrorMessage("network")}
                    label="Network"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledDropDowntWithFloatingLabel
                    name="status"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={listStatusDD}
                    isError={errors["status"]}
                    errorMsg={getFormErrorMessage("status")}
                    label="Status"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={3} mb={2}>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      margin: "0px 0px 0px 10px",
                    }}
                  >
                    <Button
                      type="button"
                      label={"Search"}
                      className="p-button-raised"
                      onClick={handleSubmit(onSubmit)}
                    />
                    <Button
                      type="button"
                      label={"Reset Filters"}
                      className="p-button-raised p-button-secondary"
                      onClick={handleResetFilters}
                    />
                  </div>
                </Grid>
              </Grid>
            </form>
          </div>

          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box>
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={
                  isSearch
                    ? "No Reservations records to show"
                    : "Please use the search filters above to find reservations"
                }
              />
            )}
          </div>

          {/* Reservation Summary Section */}
          {reservationSummary && (
            <div className="reservation-summary-section" style={{ marginTop: '20px', marginBottom: '20px' }}>
              <h4 style={{ 
                fontSize: '18px', 
                fontWeight: '600', 
                marginBottom: '15px', 
                color: '#333',
                borderBottom: '2px solid #1976d2',
                paddingBottom: '8px'
              }}>
                Reservation Summary
              </h4>
              <Grid container spacing={2}>
                {/* Reservation Stats */}
                <Grid item xs={12} md={4}>
                  <div style={{ 
                    backgroundColor: '#f8f9fa', 
                    padding: '15px', 
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0'
                  }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Total Reservations</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{paginationInfo?.totalRecords || 0}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Total Cancelled</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.totalCancel ? reservationSummary.totalCancel.replace(')', '%)') : '0'}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Total Modified</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.totalModified ? reservationSummary.totalModified.replace(')', '%)') : '0'}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Total No Shows</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.totalNoShow ? reservationSummary.totalNoShow.replace(')', '%)') : '0'}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Total Unconfirmed</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.unConfirmed ? reservationSummary.unConfirmed.replace(')', '%)') : '0'}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Grid>

                {/* Customer Stats */}
                <Grid item xs={12} md={4}>
                  <div style={{ 
                    backgroundColor: '#f8f9fa', 
                    padding: '15px', 
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0'
                  }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>New Customer</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.totalNewCustomer ? reservationSummary.totalNewCustomer.replace(')', '%)') : '0'}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Repeating Customer</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.totalRepeatingCustomer ? reservationSummary.totalRepeatingCustomer.replace(')', '%)') : '0'}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Average Cancelled Reservation Days</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.avgCancelledReservationDays || 0}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Average Days</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.avgDays || 0}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#555' }}>Total Days</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>{reservationSummary.totalDays || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Grid>

                {/* Revenue Stats */}
                <Grid item xs={12} md={4}>
                  <div style={{ 
                    backgroundColor: '#e8f5e9', 
                    padding: '15px', 
                    borderRadius: '8px',
                    border: '1px solid #c8e6c9'
                  }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#2e7d32' }}>Total Revenue</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '700', color: '#2e7d32', fontSize: '16px' }}>
                            $ {typeof reservationSummary.totalRevenue === 'number' ? reservationSummary.totalRevenue.toFixed(2) : reservationSummary.totalRevenue || '0.00'}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 0', fontWeight: '500', color: '#2e7d32' }}>Average Reservation Revenue</td>
                          <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '700', color: '#2e7d32', fontSize: '16px' }}>
                            $ {typeof reservationSummary.avgReservationRevenue === 'number' ? reservationSummary.avgReservationRevenue.toFixed(2) : reservationSummary.avgReservationRevenue || '0.00'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Grid>
              </Grid>
            </div>
          )}
        </div>
      </Container>
    </>
  );
};
export default ReservationsReservations;
